<div class="modal fade" id="addOrganizationModal" msEscClose (escPressed)="onCancel()"
    data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header border-0 p-4">
                <h5 class="modal-title">Add Organization</h5>
            </div>
            <div class="modal-body text-center">
                <ms-add-organization-form (submissionResult)="onAddOrganizationResult($event)" (cancelRequested)="onCancel()" #addOrganizationFormRef>
                </ms-add-organization-form>
            </div>
        </div>
    </div>
</div>

<ms-info-modal #organizationFormInfoModalRef modalId="organizationFormInfoModal" (onConfirm)="infoModalConfirmed()" />

<ms-confirmation-modal 
    #organizationFormConfirmationModalRef
    modalId="organizationFormConfirmationModal" 
    confirmButtonText="Leave"
    cancelButtonText="Stay"
    (confirmed)="confirmationModalConfirmed()"
    (cancelled)="confirmationModalCancelled()"
/>